//
// Comment dit "Hamburger" en Anglais?
// © 2016, Matt Scheurich
//

var map = require('lodash.map')
var visuals = require('./visuals.js')
var THREELoader = window.THREELoader || {}

// Props
var showInfo = false
var showCtrl = false
var isLoaded = false

/*
 * Avoiding using jQuery
 */

// Query one
function $ (selector, el) {
  if (!el) {
    el = document
  }
  return el.querySelector(selector)
}

// Query all
function $$ (selector, el) {
  if (!el) {
    el = document
  }
  return Array.prototype.slice.call(el.querySelectorAll(selector))
}

/*
 * Elements
 */

var $body = $('body')
var $debug = $('#debug')
var $highquality = $('#highquality')

/*
 * Funky methods
 */

// Show loading progress
THREELoader.onProgress = function (item, loaded, total) {
  var amount = Math.ceil((loaded / total) * 100)

  if (!isLoaded) {
    if (amount >= 25 && !$body.className.match(/\bloaded-25\b/)) {
      $body.className = ($body.className + ' loaded-25').trim()
    } else if (amount >= 50 && !$body.className.match(/\bloaded-50\b/)) {
      $body.className = ($body.className + ' loaded-50').trim()
    } else if (amount >= 75 && amount < 100 && !$body.className.match(/\bloaded-75\b/)) {
      $body.className = ($body.className + ' loaded-75').trim()
    } else if (amount === 100 && !$body.className.match(/\bloaded-100\b/)) {
      isLoaded = true
      $body.className = ($body.className + ' loaded-100').trim()

      // Remove loading class
      $body.className = $body.className.replace(/\bis\-loading\b/, '').trim()

      // After some time, remove the loaded helper classes
      setTimeout(function () {
        $body.className = $body.className.replace(/\bloaded\-\d+\b/g, '').trim()
      }, 1000)
    }
  }
}

// Update play class
function updateClassPlay (setMode) {
  setMode = (typeof setMode === 'undefined' ? !visuals.doAnimate : setMode)

  if (setMode) {
    $body.className = ($body.className + ' is-playing').trim()

    // Play the tunes
  } else {
    $body.className = $body.className.replace(/\bis\-playing\b/, '').trim()

    // Pause the tunes
  }

  visuals.doAnimate = setMode
}

// Update class info
function updateClassInfo (setMode) {
  setMode = (setMode !== undefined ? setMode : !!showInfo)

  if (!setMode) {
    $body.className = ($body.className + ' info-open').trim()
    showInfo = true

    // Pause visuals
    updateClassPlay(false)
    visuals.blur()

  } else {
    $body.className = $body.className.replace(/\binfo\-open\b/, '').trim()
    showInfo = false

    // Resume visuals
    updateClassPlay(true)
    visuals.focus()
  }
}

// Update class ctrl
function updateClassCtrl (setMode) {
  setMode = (setMode !== undefined ? setMode : !!showCtrl)

  if (!setMode) {
    $body.className = ($body.className + ' ctrl-open').trim()
    showCtrl = true
  } else {
    $body.className = $body.className.replace(/\bctrl\-open\b/, '').trim()
    showCtrl = false
  }
}

function generateComposition () {
  // No ctrl open means uses default values
  if (!showCtrl) {
    visuals.generateComposition()
    return
  }

  // Get values from form
  var width = parseFloat($('#box-width').value)
  var height = parseFloat($('#box-height').value)
  var depth = parseFloat($('#box-depth').value)
  var cellWidth = parseFloat($('#cell-width').value)
  var cellHeight = parseFloat($('#cell-height').value)
  var cellDepth = parseFloat($('#cell-depth').value)
  var deviation = parseFloat($('#deviation').value)
  var debug = $('#debug').checked

  visuals.generateComposition(width, height, depth, cellWidth, cellHeight, cellDepth, deviation, debug)
}

/*
 * Events
 */

// Keyboard events
document.addEventListener('keyup', function (event) {
  // Only do keyboard shortcuts if a render is active
  if (isLoaded && visuals.renderer) {
    // Start/stop animation (s)
    if (event.which === 83 && !visuals.isBlurred) {
      if (visuals.doAnimate) {
        visuals.doAnimate = false
      } else {
        visuals.doAnimate = true
      }
    }

    // Generate new composition (n)
    if (event.which === 78) {
      generateComposition()
    }

    // Change the camera (d, p, x, y, z)
    if (event.which === 68 || event.which === 80 || (event.which >= 88 && event.which <= 90)) {
      visuals.changeCamera(event.which)
    }

    // Show/hide controls (q)
    if (event.which === 81) {
      updateClassCtrl()
    }

    // Show/hide wireframe (w)
    if (event.which === 87) {
      $debug.checked = !$debug.checked
      visuals.debug.visible = $debug.checked
    }

    // Show/hide info (i)
    if (event.which === 73) {
      updateClassInfo()
    }
  }
}, false)

// Click the pause button
$('#pause').addEventListener('click', function (event) {
  event.preventDefault()
  updateClassPlay(false)
  return false
}, false)

// Click the play button
$('#play').addEventListener('click', function (event) {
  event.preventDefault()
  updateClassPlay(true)
  return false
}, false)

// Click the new button
map($$('.generate'), function (elem) {
  elem.addEventListener('click', function (event) {
    event.preventDefault()
    generateComposition()
    return false
  }, false)
})

// Click a ctrl toggle
map($$('.ctrl-toggle'), function (elem) {
  elem.addEventListener('click', function (event) {
    event.preventDefault()
    updateClassCtrl()
    return false
  }, false)
})

// Click an info toggle
map($$('.info-toggle'), function (elem) {
  elem.addEventListener('click', function (event) {
    event.preventDefault()
    updateClassInfo()
    return false
  }, false)
})

// Wireframes toggle
$debug.addEventListener('click', function (event) {
  if (event.target.checked) {
    visuals.debug.visible = true
  } else {
    visuals.debug.visible = false
  }
})

// Quality toggle
var debounce = 0
$highquality.addEventListener('click', function (event) {
  // Disabled
  if ($highquality.disabled) {
    event.preventDefault()
    return false
  }

  // Don't rush me!
  clearTimeout(debounce)
  $highquality.disabled = true
  if (event.target.checked) {
    debounce = setTimeout(function () {
      $highquality.disabled = false
      visuals.highQuality()
    }, 500)
  } else {
    debounce = setTimeout(function () {
      $highquality.disabled = false
      visuals.lowQuality()
    }, 500)
  }
})
